module.exports = __webpack_public_path__ + "img/hanky_panky.091a787f.jpg";